(($) => {
  const self = $('.js-header-user');
  $(window).on('click touchstart', () => {
    self.removeClass('is-expanded');
  });
  self.on('click touchstart', function (event) {
    event.stopPropagation();
  }).on('click touchstart', '[data-toggle]', function (event) {
    self.toggleClass('is-expanded');
    event.preventDefault();
  });
})(jQuery);
